const isDevMode =
  !process.env.NODE_ENV || process.env.NODE_ENV === "development";

class ENVProvider {
  env = {
    // env
    env: process.env.ENV_PHASE || "-",
    isDevMode,
    version: "Vesion - 0.0.1",
    // Base url
    baseUrl: "",
    baseOCRUrl: "",
    baseMRZUrl: "",
    oneUrl: "",
    oneClientId: null,
    loginRedirectUrl: "",
    logoutRedirectUrl: "",
  };

  getConfig() {
    return this.env;
  }

  setConfig(envResource) {
    this.env = {
      ...this.env,
      version: envResource.REACT_APP_VERSION || "Vesion - 0.0.1",
      // Base url
      baseUrl: envResource.REACT_APP_BASE_URL || "",
      // baseUrl: envResource.REACT_APP_BASE_URL_LOCAL || "",
      baseOCRUrl: envResource.REACT_APP_BASE_OCR_URL || "",
      baseMRZUrl: envResource.REACT_APP_BASE_MRZ_URL || "",
      oneUrl: envResource.REACT_APP_ONE_URL || "",
      oneClientId: envResource.REACT_APP_ONE_CLIENT_ID,
      loginRedirectUrl: isDevMode
        ? "http://localhost:3000/login"
        : envResource.REACT_APP_LOGIN_REDIRECT_URL,
      logoutRedirectUrl: isDevMode
        ? "http://localhost:3000/logout"
        : envResource.REACT_APP_LOGOUT_REDIRECT_URL,
    };
  }

  async init() {
    const response = await fetch("/resources/env.json");
    const results = await response.json();
    this.setConfig(results);
  }
}

export const envInstants = new ENVProvider();

export default envInstants;
